<template>
  <div class="col-md-12">
    <div class="card card-container">
      <h4><font-awesome-icon icon="plus-square" /> Add Sale</h4>
      <form name="form" @submit.prevent="saveSale">
        <div v-if="!successful">
          <div class="form-group">
            <label for="products">Select Product:</label>
            <select v-model="sale.productId" @change="onChangeProduct($event)" v-validate="'required'" class="form-control" id="productId" name="productId">
              <option selected disabled value="">Please select one</option>
              <option v-for="product in products" v-bind:value="product.id" :key="product.id" :id="product.pv">{{ product.name }}</option>
            </select>
            <div v-if="submitted && errors.has('products')" class="alert-danger">{{errors.first('products')}}</div>
          </div>
          <div class="form-group">
            <label for="quantity">Quantity:</label>
            <input v-model="sale.quantity" v-validate="'required|min:1|max:6'" type="number" class="form-control" id="quantity" name="quantity"/>
            <div v-if="submitted && errors.has('quantity')" class="alert-danger" >{{errors.first('quantity')}}</div>
          </div>
          <div class="form-group">
            <label for="soldDate">Sold Date:</label>
            <input v-model="sale.soldDate" v-validate="'required|min:10|max:10'" type="date" class="form-control" id="soldDate" name="soldDate"/>
            <div v-if="submitted && errors.has('soldDate')" class="alert-danger" >{{errors.first('soldDate')}}</div>
          </div>
          <!-- <div class="form-group">
            <label for="members">Select Member:</label>
            <select v-model="sale.memberId" @change="onChangeMember($event)" v-validate="'required|min:9|max:12'" class="form-control" id="memberId" name="memberId">
              <option selected disabled value="">Please select one</option>
              <option v-for="member in members" v-bind:value="member.id" :key="member.id">{{ member.id }} ({{ member.surname }}, {{ member.first_name }})</option>
            </select>
            <div v-if="submitted && errors.has('members')" class="alert-danger">{{errors.first('members')}}</div>
          </div> -->
          <div class="form-group">
            <label for="memberId">Member:</label>
            <input v-model="sale.memberId" v-validate="'required|min:9|max:12'" type="number" class="form-control" id="memberId" name="memberId"/>
            <div v-if="submitted && errors.has('memberId')" class="alert-danger" >{{errors.first('memberId')}}</div>
          </div>
          <div class="form-group">
            <button type="submit" class="m-3 btn btn-sm btn-success"><font-awesome-icon icon="save" /> Save</button>
            <button class="m-3 btn btn-sm btn-primary" @click="salesList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      <div v-if="message && successful">
        <button class="btn btn-primary" @click="newSale"><font-awesome-icon icon="plus" /> Add Sale</button>
      </div>
    </div>
  </div>
</template>

<script>
import SaleService from "../services/sale.service";
import MemberService from "../services/member.service";
import ProductService from "../services/product.service";

export default {
  name: 'add-sale',
  data() {
    return {
      sale: {
        id: null,
        pv: 0,
        quantity: 0,
        totalPv: 0,
        receiptNo: '',
        soldDate: '',
        memberId: '',
        productId: null
      },
      submitted: false,
      successful: false,
      message: '',
      members: [],
      products: [],
      currentProduct: null,
      min: 1000000000,
      max: 9999999999,
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    retrieveMembers() {
      MemberService.getAll()
        .then(response => {
          this.members = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    onChangeMember: function(e) {
      this.sale.memberId = e.target.value;
    },

    retrieveProducts() {
      ProductService.getAll()
        .then(response => {
          this.products = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    onChangeProduct: function(e) {
      this.sale.productId = e.target.value;
      this.sale.pv = event.target.options[event.target.options.selectedIndex].id;
    },

    getProduct(id) {
      ProductService.get(id)
        .then(response => {
          this.currentProduct = response.data;
          console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    randomNumber : function(){
      return Math.floor(Math.random() * this.max) + this.min;
    },

    /*saveSale() {
      this.sale.totalPv = this.sale.pv * this.sale.quantity;
      this.sale.receiptNo = 'HMAXREG' + this.randomNumber();
      var saleData = {
        //id: this.sale.id,  
        pv: this.sale.pv,
        quantity: this.sale.quantity,
        totalPv: this.sale.totalPv,
        receiptNo: this.sale.receiptNo,
        soldDate: this.sale.soldDate,
        memberId: this.sale.memberId,
        productId: this.sale.productId
      };
      this.message = '';
      this.submitted = true;
      this.$validator.validate().then(isValid => {
        if (isValid) {
          SaleService.create(saleData).then(
            response => {
              this.message = 'The sale was created successfully!';
              this.sale.id = response.data.id;
              //console.log('data: '+response.data);
              this.submitted = true;
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log('e: '+e);
              this.message = e.message;
              console.log('e message: '+e.message);
            });
        }
      });
    },*/

    saveSale() {
      MemberService.memberExist(this.sale.memberId)
        .then(response => {
          let memberExistRes = response.data;
          //console.log(response.data);
          if(memberExistRes <= 0){
            this.message = 'Invalid Member ID!';
            this.successful = false;
          }
          else{ 
            this.sale.totalPv = this.sale.pv * this.sale.quantity;
            this.sale.receiptNo = 'HMAXREG' + this.randomNumber();
            var saleData = {
              //id: this.sale.id,  
              pv: this.sale.pv,
              quantity: this.sale.quantity,
              totalPv: this.sale.totalPv,
              receiptNo: this.sale.receiptNo,
              soldDate: this.sale.soldDate,
              memberId: this.sale.memberId,
              productId: this.sale.productId
            };
            this.message = '';
            this.submitted = true;
            this.$validator.validate().then(isValid => {
              if (isValid) {
                SaleService.create(saleData).then(
                  response => {
                    this.message = 'The sale was created successfully!';
                    this.sale.id = response.data.id;
                    //console.log('data: '+response.data);
                    this.submitted = true;
                    this.successful = true;
                  },
                  error => {
                    this.message = (error.response && error.response.data) || error.message || error.toString();
                    this.successful = false;
                  })
                  .catch(e => {
                    console.log('e: '+e);
                    this.message = e.message;
                    console.log('e message: '+e.message);
                  });
              }
            });

          }

        })
        .catch(e => {
          console.log(e);
        });

    },

    newSale() {
      this.submitted = false;
      this.successful = false;
      this.message = '';
      this.sale = {};
    },
    
    salesList() {
      this.$router.push('/sales');
    }
  },

  mounted() {
    //this.retrieveMembers();
    this.retrieveProducts();
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>